import type { SupportedLocale } from "../locales/catalog-registry";

/**
 * Visible **`select`** label for each shipped locale, written in that locale (**autonym**),
 * so option text stays recognizable regardless of the active UI language.
 */
const LOCALE_AUTONYMS: Record<SupportedLocale, string> = {
  da: "Dansk",
  de: "Deutsch",
  en: "English",
  /** Non-ASCII via escapes (repository **`encoding.md`** source rule). */
  fr: "Fran\u00e7ais",
  /** Ukrainian autonym in Cyrillic via escapes. */
  uk: "\u0423\u043a\u0440\u0430\u0457\u043d\u0441\u044c\u043a\u0430",
};

/**
 * End-user label for a locale option (**native name** of the language).
 *
 * @param loc - Shipped **`SupportedLocale`** tag.
 */
export function localeOptionAutonym(loc: SupportedLocale): string {
  return LOCALE_AUTONYMS[loc];
}
